import Cookies from "js-cookie";

export const getGuideReviewImageUrl = (reviewId: string) =>
    `${process.env.REACT_APP_BACKEND_URL}/guide-reviews/${reviewId}/image`;

export const fetchGuideReviewImageBlob = async (reviewId: string): Promise<Blob> => {
    const token = Cookies.get("accessToken");
    const imageUrl = getGuideReviewImageUrl(reviewId);

    const res = await fetch(imageUrl, {
        headers: { Authorization: `Bearer ${token}` },
    });

    if (!res.ok) {
        throw new Error("Failed to load image");
    }

    return res.blob();
};

export const fetchGuideReviewDisplayUrl = async (reviewId: string): Promise<string> => {
    const blob = await fetchGuideReviewImageBlob(reviewId);
    return URL.createObjectURL(blob);
};
